import React from 'react'
import Card from './Card'
import CreateListCard from './CreateListCard'

const List = (props) => {
  return (
    <div className='flex flex-wrap'>
      <CreateListCard
        location={props.location}
        createContactList={props.createContactList}
        className='ma3'/>
      {(props.isFetchingList) ? (
        <div className='dib'>
          Fetching contact lists...
        </div>
      ) : props.contacts.map((val, index) => (
        <Card
          location={props.location}
          key={index}
          name={val.name}
          id={val.id}
          className='ma3'/>
      ))}
    </div>
  )
}

export default List



// WEBPACK FOOTER //
// ./src/components/ContactList/List.js